import React, { useEffect, useState, useRef } from "react";
import { usePaymentDropdowns } from "../../hooks/usePaymentDropdowns";
import { Row, Col, Button, Input, Select, Spin, Typography, AutoComplete, Checkbox, DatePicker, Descriptions, notification } from "antd";
import axios from "axios";
import { baseUrl } from "../../config";
import { SearchOutlined, FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import '../../assets/styles/custom_style.css';
import moment from 'moment';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { getPermissions, hasPermission } from '../../components/permissions';

const { Option } = Select;
const { Title } = Typography;
const { RangePicker } = DatePicker;

function FilterReport({ onFiltersChange }) {
  const { bankAccounts, specialOccasions } = usePaymentDropdowns();

  const [selectedFilterSection, setselectedFilterSection] = useState("paymentFilter");
  const [loading, setLoading] = useState(false); // State to manage the loade
  const handleFilterCheckboxCheck = (formType) => {
    setselectedFilterSection(selectedFilterSection === formType ? null : formType);
  };

  const [filters, setFilters] = useState({
    name: '',
    email: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    createdBy: ''
  });

  const [filtersColumn, setFiltersColumn] = useState({})

  const handleFilterChange = (field, value) => {
    console.log(field, value)
    setFilters(prevFilters => {
      const newFilters = {
        ...prevFilters,
        [field]: value
      };
      // Notify the parent component about the filter change
      // onFiltersChange(newFilters);
      return newFilters;
    });
  };

  const handleFilterChangeColumns = (field, key, value) => {
    console.log("field", field);
    console.log("value", value);
    setFiltersColumn({
      ...filtersColumn,
      [key]: value
    });
  };

  // Optional: Notify parent component of initial filters state
  useEffect(() => {
    onFiltersChange(filters);
  }, []);


  // Get Suggestion Values
  const [optionSuggestion, setOptionSuggestion] = useState([]);
  const getPanelValue = async (searchText, columnName, tableName) => {
    if (searchText.length < 3) {
      setOptionSuggestion([]);
      return;
    }

    try {
      const response = await axios.get(`${baseUrl}/payments/getSuggestionValue/`, {
        params: { q: searchText, column: columnName, table: tableName },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
        },
      });
      if (response.status === 200) {
        setOptionSuggestion(response.data.result);
      }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // Village multi-select from master
  const [villageOptions, setVillageOptions] = useState([]);
  const [villageSearching, setVillageSearching] = useState(false);
  const villageTimerRef = useRef(null);
  const getVillageSuggestions = (searchText) => {
    clearTimeout(villageTimerRef.current);
    if (!searchText || searchText.length < 1) { setVillageOptions([]); return; }
    setVillageSearching(true);
    villageTimerRef.current = setTimeout(async () => {
      try {
        const res = await axios.get(`${baseUrl}/village/search`, {
          params: { q: searchText },
          headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
        });
        setVillageOptions((res.data.result || []).map(v => {
          const parts = [v.name_en];
          if (v.name_hn) parts.push(v.name_hn);
          const loc = [v.tehsil_en, v.district_en].filter(Boolean).join(', ');
          return { value: v.name_en, label: loc ? `${parts.join(' / ')} — ${loc}` : parts.join(' / ') };
        }));
      } catch { setVillageOptions([]); }
      finally { setVillageSearching(false); }
    }, 300);
  };

  const [tehsilOptions, setTehsilOptions] = useState([]);
  const [tehsilSearching, setTehsilSearching] = useState(false);
  const tehsilTimerRef = useRef(null);
  const getTehsilSuggestions = (q) => {
    clearTimeout(tehsilTimerRef.current);
    if (!q || q.length < 1) { setTehsilOptions([]); return; }
    setTehsilSearching(true);
    tehsilTimerRef.current = setTimeout(async () => {
      try {
        const res = await axios.get(`${baseUrl}/village/search-tehsil`, {
          params: { q }, headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
        });
        setTehsilOptions((res.data.result || []).map(v => ({
          value: v.tehsil_en,
          label: `${v.tehsil_en}${v.tehsil_hn ? ' / ' + v.tehsil_hn : ''}`
        })));
      } catch { setTehsilOptions([]); }
      finally { setTehsilSearching(false); }
    }, 300);
  };

  const [districtOptions, setDistrictOptions] = useState([]);
  const [districtSearching, setDistrictSearching] = useState(false);
  const districtTimerRef = useRef(null);
  const getDistrictSuggestions = (q) => {
    clearTimeout(districtTimerRef.current);
    if (!q || q.length < 1) { setDistrictOptions([]); return; }
    setDistrictSearching(true);
    districtTimerRef.current = setTimeout(async () => {
      try {
        const res = await axios.get(`${baseUrl}/village/search-district`, {
          params: { q }, headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
        });
        setDistrictOptions((res.data.result || []).map(v => ({
          value: v.district_en,
          label: `${v.district_en}${v.district_hn ? ' / ' + v.district_hn : ''}`
        })));
      } catch { setDistrictOptions([]); }
      finally { setDistrictSearching(false); }
    }, 300);
  };

  const UserReportOptions = [
    { label: 'Email', value: 'email_address' },
    { label: 'DOB', value: 'dob' },
    { label: 'Maritial Status', value: 'maritial_status' },
    { label: 'Caste', value: 'caste' },
    { label: 'Gotra', value: 'gotra' },
    { label: 'Kuldevi', value: 'kuldevi' },
    { label: 'Kulrishi', value: 'kulrishi' },
    { label: 'Alt Phone no', value: 'alternate_phone_no' },
    { label: 'Alt Phone 2', value: 'alternate_phone_no2' },
    { label: 'PAN Card No', value: 'pan_number' },
    { label: 'Aadhar No', value: 'aadhar_no' },
    { label: 'Status', value: 'member_status' }
  ];

  const PaymentReportOptions = [
    { label: 'Receipt No.', value: 'payment_id' },
    { label: 'Monthly Share', value: 'month_share_amount' },
    { label: 'Account', value: 'bank_account' },
    { label: 'Special Occ.', value: 'special_occassion_category' },
    { label: 'First Payment Date', value: 'first_payment_date' },
    { label: 'Last Payment Date', value: 'last_payment_date' },
    { label: 'Received Amount', value: 'total_received_amount' },
    { label: 'Due Amount', value: 'total_due_amount' },
    { label: 'Tnx Detail', value: 'utr_number' },
    { label: 'Mode of Payment', value: 'pyament_mode_type' },
    { label: 'Duration', value: 'duration_type' },
    { label: 'Last Response', value: 'latest_payment_response' },
    { label: 'Up to Month', value: 'end_month' },
    { label: 'Remarks', value: 'remarks' },
    { label: 'C/R-Reciept', value: 'e_reciept_no' },
    { label: 'C/R-Date', value: 'e_reciept_date' },

  ];

  const PerAddressReportOptions = [
    { label: 'Street/House No', value: 'per_address' },
    { label: 'Post', value: 'per_post' },
    { label: 'Tehsil', value: 'per_tahsil' },
    { label: 'Zip Code', value: 'per_pin_code' },
    { label: 'State', value: 'per_state' },
    { label: 'Country', value: 'per_country	' }
  ];

  const TemAddressReportOptions = [
    { label: 'Street/House No', value: 'tem_address' },
    { label: 'Street', value: 'tem_street' },
    { label: 'City', value: 'tem_city' },
    { label: 'Zip Code', value: 'tem_pin_code' },
    { label: 'District', value: 'tem_district' },
    { label: 'State', value: 'tem_state' },
    { label: 'Country', value: 'tem_country	' }
  ];

  const OccReportOptions = [
    { label: 'Occ. Name', value: 'occ_name' },
    { label: 'Occ. Field', value: 'occ_field' },
    { label: 'Occ. Category', value: 'occ_category' },
    { label: 'Shop no.', value: 'shop_no' },
    { label: 'Building Name', value: 'building_name' },
    { label: 'Locality', value: 'occ_locality' },
    { label: 'District', value: 'occ_district' },
    { label: 'State', value: 'occ_state' },
    { label: 'Country', value: 'occ_country' },
    { label: 'Zip Code', value: 'occ_zip_code' },
    { label: 'Office Phone no.', value: 'is_occ_office_phone_no	' },
    { label: 'Phone no.', value: 'is_occ_mobile_no	' }
  ];

  const FamilyReportOptions = [
    { label: 'Name', value: 'm_name' },
    { label: 'Relation Name', value: 'm_relation_name' },
    { label: 'Education', value: 'm_education' },
    { label: 'Occupation', value: 'm_occupation' },
    { label: 'Current Address', value: 'm_current_address' },
    { label: 'Phone no', value: 'm_phone_no' },
    { label: 'Email', value: 'm_email' }
  ];

  const SocialReportOptions = [
    { label: 'Organisation Name', value: 'sn_organisation_name' },
    { label: 'Post', value: 'sn_post' },
    { label: 'Duration Start', value: 'sn_duration_start' },
    { label: 'Duration End', value: 'sn_duration_end' },
    { label: 'Organisation Address', value: 'sn_organisation_address' },
    { label: 'Phone no', value: 'is_org_phone_no' }
  ];


  const handleExcelDownload = async () => {
    setLoading(true);
    const filterParams = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&');

    try {
      const response = await axios.get(`${baseUrl}/users/manualReport?${filterParams}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      console.log("response.data", response);
      if (response.status === 200) {
        setLoading(false);
        const formattedData = response.data.result.map((user, index) => {
          let userData = {
            "SR.no": index + 1,
            "Phone no": user.phone_no,
            "Name": user.name,
            "Relation": user.relation,
            "Father Name": user.father_name,
            "Village": user.per_village,
            "District": user.per_district,
            "Joining date": user.joining_date ? moment(user.joining_date).format('DD-MM-YYYY') : '-',
            "Monthly Share": user.monthly_share || user.announced_amount || '-',
          };

          // Dynamically add fields based on the dynamicFields object
          Object.keys(filtersColumn).forEach(field => {
            if (filtersColumn[field] && user[field] !== undefined) {
              // Format the key for the excel sheet if needed
              let formattedKey = field.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());

              // Check if the field is 'dob' and format it accordingly  
              if (field === 'dob' || field === 'first_payment_date' || field === 'last_payment_date' || field === 'sn_duration_start' || field === 'sn_duration_end' || field === 'e_reciept_date') {
                // console.log(`Formatting date field - ${field}`);
                userData[formattedKey] = user[field] ? moment(user[field]).format('DD-MM-YYYY') : '-';
              } else if (field === 'end_month') {
                userData[formattedKey] = user[field] ? moment(user[field]).format('MM-YYYY') : '-';

              }
              else {
                userData[formattedKey] = user[field];
              }
            }
          });

          return userData;
        });

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Manual Report");
        XLSX.writeFile(workbook, "Manually-Report.xlsx");
      } else {
        setLoading(false);
        notification.info({
          message: 'Info',
          description: response.data.message,
          placement: 'topRight'
        });
      }
    } catch (error) {
      setLoading(false);
      console.error('Error downloading Excel file:', error);
      notification.error({
        message: 'Download Error',
        description: 'An error occurred while downloading the Excel file.',
        placement: 'topRight'
      });
    }
  };

  const handlePdfDownload = async () => {
    setLoading(true);
    const initialColumns = [
      "Name",
      "Phone no",
      "Relation",
      "Father Name",
      "Village",
      "District",
      "Joining date"
    ];

    // Calculate total columns and check if it exceeds 10
    const additionalFields = Object.keys(filtersColumn).filter(field => filtersColumn[field]);
    const totalColumns = initialColumns.length + additionalFields.length;

    if (totalColumns > 10) {
      notification.error({
        message: 'Download Error',
        description: 'The total number of columns exceeds the limit of 10. Please adjust your columns.',
        placement: 'topRight'
      })
      return;
    }


    const filterParams = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&');

    try {
      const response = await axios.get(`${baseUrl}/users/manualReport?${filterParams}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      console.log("response.data", response);
      if (response.status === 200) {
        setLoading(false);
        const formattedData = response.data.result.map((user, index) => {
          let userData = {
            "SR.no": index + 1,
            "Name": user.name,
            "Phone no": user.phone_no,
            "Relation": user.relation,
            "Father Name": user.father_name,
            "Village": user.per_village,
            "District": user.per_district,
            "Joining date": user.joining_date ? moment(user.joining_date).format('DD-MM-YYYY') : '-',
          };

          // Dynamically add fields based on the filtersColumn object
          Object.keys(filtersColumn).forEach(field => {
            if (filtersColumn[field] && user[field] !== undefined) {
              let formattedKey = field.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
              userData[formattedKey] = user[field];
            }
          });

          return userData;
        });

        const doc = new jsPDF('landscape'); // Use landscape mode for better fit
        // Base64 encoded font string
        const notoSansDevanagariBase64 = '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'

        // Add the font to jsPDF
        doc.addFileToVFS('NotoSansDevanagari-Regular.ttf', notoSansDevanagariBase64);
        doc.addFont('NotoSansDevanagari-Regular.ttf', 'NotoSansDevanagari', 'normal');
        doc.setFont('NotoSansDevanagari');
        console.log("Font added and set.");

        const tableColumn = Object.keys(formattedData[0]);
        const tableRows = formattedData.map(user => tableColumn.map(column => user[column]));

        // Set autoTable options for responsive design
        doc.autoTable({
          head: [tableColumn],
          body: tableRows,
          font: 'NotoSansDevanagari', // Use the Hindi font
          startY: 10,
          styles: {
            fontSize: 8, // Adjust font size for better fit
            cellPadding: 2, // Adjust padding to save space
            overflow: 'linebreak', // Handle content overflow
          },
          columnStyles: {
            0: { cellWidth: 'auto' }, // Adjust cell width dynamically
            1: { cellWidth: 'auto' },
            2: { cellWidth: 'auto' },
            // Add more columns as needed
          },
          didDrawCell: (data) => {
            if (data.column.index === 0 && data.cell.section === 'body') {
              // Adjust the first column to fit the content
              data.cell.styles.cellWidth = 'wrap';
            }
          },
          theme: 'grid', // Use 'grid' theme for a more readable table
          margin: { top: 10, right: 10, bottom: 10, left: 10 } // Add margins for better readability
        });

        doc.save("report.pdf");

      } else {
        setLoading(false);
        notification.info({
          message: 'Info',
          description: response.data.message,
          placement: 'topRight'
        });
      }
    } catch (error) {
      setLoading(false);
      console.error('Error downloading PDF file:', error);
      notification.error({
        message: 'Download Error',
        description: 'An error occurred while downloading the PDF file.',
        placement: 'topRight'
      });
    }
  };

  const handleSearchReport = () => {
    onFiltersChange(filters);
  };

  const handleResetFilters = () => {
    setFilters({
      name: '',
      email: '',
      phone: '',
      city: '',
      state: '',
      country: '',
      createdBy: '',
      per_village_en: []
    });
    setVillageOptions([]);
    onFiltersChange({});
  };



  return (
    <>

      {
        loading && (
          <div className="full-page-loader">
            <Spin size="large" />
          </div>
        )
      }

      <Descriptions bordered column={{ xs: 1, sm: 2, lg: 6 }} className="ModalTable">
        <Descriptions.Item label="Basic Details">
          <Checkbox
            checked={selectedFilterSection === 'userFilter'}
            onChange={() => handleFilterCheckboxCheck('userFilter')}
          ></Checkbox>
        </Descriptions.Item>
        <Descriptions.Item label="Payment Details">
          <Checkbox
            checked={selectedFilterSection === 'paymentFilter'}
            onChange={() => handleFilterCheckboxCheck('paymentFilter')}
          ></Checkbox>
        </Descriptions.Item>
        <Descriptions.Item label="Address">
          <Checkbox
            checked={selectedFilterSection === 'addressFilter'}
            onChange={() => handleFilterCheckboxCheck('addressFilter')}
          ></Checkbox>
        </Descriptions.Item>
        <Descriptions.Item label="Occ Details">
          <Checkbox
            checked={selectedFilterSection === 'occFilter'}
            onChange={() => handleFilterCheckboxCheck('occFilter')}
          ></Checkbox>
        </Descriptions.Item>
        <Descriptions.Item label="Family Details">
          <Checkbox
            checked={selectedFilterSection === 'familyFilter'}
            onChange={() => handleFilterCheckboxCheck('familyFilter')}
          ></Checkbox>
        </Descriptions.Item>
        <Descriptions.Item label="Social Status">
          <Checkbox
            checked={selectedFilterSection === 'socialFilter'}
            onChange={() => handleFilterCheckboxCheck('socialFilter')}
          ></Checkbox>
        </Descriptions.Item>
      </Descriptions>




      {/* User Details Filter Start here */}
      {selectedFilterSection === 'userFilter' && (
        <>
          <Col xs={24}> <Title style={{ fontSize: 13 }} level={5}>User Details</Title>  </Col>
          <Col span={4}>
            <Input placeholder="Phone" value={filters.phone} onChange={e => handleFilterChange('phone', e.target.value)}
            />

          </Col>
          <Col span={4}>
            <Input placeholder="Name" value={filters.name} onChange={e => handleFilterChange('name', e.target.value)}
            />
          </Col>
          <Col span={4}>
            <Input placeholder="Email" value={filters.email} onChange={e => handleFilterChange('email', e.target.value)}
            />
          </Col>
          <Col span={4}>
            <Input placeholder="Father Name" value={filters.father_name} onChange={e => handleFilterChange('father_name', e.target.value)}
            />
          </Col>
          <Col span={4}>
            <Input placeholder="Caste" value={filters.caste} onChange={e => handleFilterChange('caste', e.target.value)}
            />
          </Col>
          <Col span={4}>
            <Input placeholder="Gotra" value={filters.gotra} onChange={e => handleFilterChange('gotra', e.target.value)}
            />
          </Col>
          <Col span={4}>
            <Input placeholder="Kuldevi" value={filters.kuldevi} onChange={e => handleFilterChange('kuldevi', e.target.value)}
            />
          </Col>
          <Col span={4}>
            <Input placeholder="Kulrishi" value={filters.kulrishi} onChange={e => handleFilterChange('kulrishi', e.target.value)}
            />
          </Col>
          <Col span={4}>
            <Input placeholder="Alt 1 No." value={filters.alternate_phone_no} onChange={e => handleFilterChange('alternate_phone_no', e.target.value)}
            />
          </Col>
          <Col span={4}>
            <Input placeholder="Alt 2 No." value={filters.alternate_phone_no2} onChange={e => handleFilterChange('alternate_phone_no2', e.target.value)}
            />
          </Col>


          <Col span={4}>

            <DatePicker className="filter_dob CustomInputSet"
              format="DD-MM-YYYY" value={filters.dob ? moment(filters.dob, 'DD-MM-YYYY') : null}
              onChange={(date, dateString) => handleFilterChange('dob', dateString)} placeholder="Date of Birth"
            />


          </Col>

          <Col span={4}>
            <DatePicker className="filter_dob CustomInputSet"
              format="DD-MM-YYYY" value={filters.joining_date ? moment(filters.joining_date, 'DD-MM-YYYY') : null}
              onChange={(date, dateString) => handleFilterChange('joining_date', dateString)} placeholder="Joining Date"
            />
          </Col>

          <Col span={4} >
            <Select className="CustomInputSet" style={{ width: '100%' }} placeholder="Maritial" value={filters.maritial_status} onChange={value => handleFilterChange('maritial_status', value)}>
              <Option value="">Select</Option>
              <Option value="Married">Married</Option>
              <Option value="UnMarried">UnMarried</Option>
              <Option value="Widowed">Widowed</Option>
            </Select>
          </Col>

          <Col span={4} >
            <Select className="CustomInputSet" style={{ width: '100%' }} placeholder="Status" value={filters.status} onChange={value => handleFilterChange('status', value)}>
              <Option value="">Select</Option>
              <Option value="Active">Active</Option>
              <Option value="Inactive">Inactive</Option>
            </Select>
          </Col>

          <Col span={6}>
            <div className="amount-range-input">
              <RangePicker
                className="filter_dob"

                format="DD-MM-YYYY"
                value={
                  Array.isArray(filters.join_date_range) && filters.join_date_range.length === 2
                    ? [moment(filters.join_date_range[0], 'DD-MM-YYYY'), moment(filters.join_date_range[1], 'DD-MM-YYYY')]
                    : []
                }
                onChange={(dates, dateStrings) => {
                  const formattedRange = dates ? dates.map(date => date.format('DD-MM-YYYY')) : [];
                  handleFilterChange('join_date_range', formattedRange);
                }}
                placeholder={['From Join', 'To Date']}
                style={{ width: '100%' }}
              />
            </div>
          </Col>

          <Col xs={24}> <Title style={{ fontSize: 13 }} level={5}>Generate Report with columns</Title>  </Col>

          <Col span={24}>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {UserReportOptions.map((option) => (
                <span key={option.value} style={{ marginRight: '16px', marginBottom: '10px' }}>
                  <Checkbox
                    key={option.value}
                    checked={filtersColumn[option.value]}
                    onChange={(e) => handleFilterChangeColumns(option.label, option.value, e.target.checked)}
                  >
                    {option.label}
                  </Checkbox>
                </span>
              ))}
            </div>
          </Col>

        </>

      )}

      {/* Payment Filter Start here */}
      {selectedFilterSection === 'paymentFilter' && (
        <>



          <Col xs={24}> <Title style={{ fontSize: 13 }} level={5}>Payment Details</Title>  </Col>

          <Col span={3}>
            <Input
              placeholder="Receipt numbers"
              value={filters.receipt_no}
              onChange={(e) => handleFilterChange('receipt_no', e.target.value)}
            />
          </Col>

          <Col span={4} >

            <Select style={{ width: '100%' }} placeholder="Account" value={filters.bank_account} onChange={value => handleFilterChange('bank_account', value)}>
              <Option value="">Select</Option>
              {bankAccounts.map(acc => (
                <Option key={acc.id} value={String(acc.id)}>{acc.account_name}</Option>
              ))}
            </Select>
          </Col>

          <Col span={4} >
            <Select style={{ width: '100%' }} placeholder="Special Occassion" value={filters.special_occassion_category} onChange={value => handleFilterChange('special_occassion_category', value)} showSearch allowClear filterOption={(input, option) => (option?.children ?? '').toLowerCase().includes(input.toLowerCase())}>
              <Option value="">Select</Option>
              {specialOccasions.map(opt => (
                <Option key={opt.id} value={opt.category_name}>{opt.category_name}</Option>
              ))}
            </Select>
          </Col>



          <Col span={4}><Input placeholder="Tnx Detail (UTR/ID)" value={filters.utr_number} onChange={e => handleFilterChange('utr_number', e.target.value)} /></Col>
          {/* <Col span={4}>
            <DatePicker className="filter_dob CustomInputSet"
              format="DD-MM-YYYY" value={filters.transaction_date ? moment(filters.transaction_date, 'DD-MM-YYYY') : null}
              onChange={(date, dateString) => handleFilterChange('transaction_date', dateString)} placeholder="Txn Date"
            />
          </Col> */}

          <Col span={4} ><Select style={{ width: '100%' }} placeholder="Mode of Payment" value={filters.pyament_mode_type} onChange={value => handleFilterChange('pyament_mode_type', value)}>
            <Option value="">Select</Option>
            <Option value="UPI">UPI</Option>
            <Option value="Cash">Cash</Option>
            <Option value="Cheque">Cheque</Option>
            <Option value="RTGS-NEFT">RTGS/NEFT</Option>
            <Option value="Website-Razorpay">Website-Razorpay</Option>
            <Option value="Application-Razorpay">Application-Razorpay</Option>
          </Select>
          </Col>

          <Col span={6}>
            <div className="amount-range-input">
              <RangePicker
                className="filter_dob"
                picker="month"
                format="MM-YYYY"
                value={
                  Array.isArray(filters.month_range) && filters.month_range.length === 2
                    ? [moment(filters.month_range[0], 'MM-YYYY'), moment(filters.month_range[1], 'MM-YYYY')]
                    : []
                }
                onChange={(dates, dateStrings) => {
                  const formattedRange = dates ? dates.map(date => date.format('MM-YYYY')) : [];
                  handleFilterChange('month_range', formattedRange);
                }}
                placeholder={['Start Month', 'End Month']}
                style={{ width: '100%' }}
              />
            </div>
          </Col>


          {/* <Col span={4} ><Select style={{ width: '100%' }} placeholder="Pay Verified Status" value={filters.payment_virify} onChange={value => handleFilterChange('payment_virify', value)}>
            <Option value="verified">Verified</Option>
            <Option value="failed">Failed</Option>
            <Option value="pending">Pending</Option>
          </Select>
          </Col> */}



          <Col span={8}>
            <div className="amount-range-input">
              <Input
                placeholder="Min Total Amount"
                value={filters.amountMin}
                onChange={(e) => handleFilterChange('amountMin', e.target.value)}
              />
              <span className="range-separator">-</span>
              <Input
                placeholder="Max Total Amount"
                value={filters.amountMax}
                onChange={(e) => handleFilterChange('amountMax', e.target.value)}
              />
            </div>
          </Col>

          <Col span={8}>
            <div className="amount-range-input">
              <Input
                placeholder="Min Monthly Share"
                value={filters.min_monthly_amount}
                onChange={(e) => handleFilterChange('min_monthly_amount', e.target.value)}
              />
              <span className="range-separator">-</span>

              <Input
                placeholder="Max Monthly Share"
                value={filters.max_monthly_amount}
                onChange={(e) => handleFilterChange('max_monthly_amount', e.target.value)}
              />

            </div>
          </Col>

          <Col span={6}>
            <div className="amount-range-input">
              <RangePicker
                className="filter_dob"

                format="DD-MM-YYYY"
                value={
                  Array.isArray(filters.txn_date_range) && filters.txn_date_range.length === 2
                    ? [moment(filters.txn_date_range[0], 'DD-MM-YYYY'), moment(filters.txn_date_range[1], 'DD-MM-YYYY')]
                    : []
                }
                onChange={(dates, dateStrings) => {
                  const formattedRange = dates ? dates.map(date => date.format('DD-MM-YYYY')) : [];
                  handleFilterChange('txn_date_range', formattedRange);
                }}
                placeholder={['Start Txn Date', 'End Txn Date']}
                style={{ width: '100%' }}
              />
            </div>
          </Col>

          <Col span={6}>
            <div className="amount-range-input">
              <RangePicker
                className="filter_dob"

                format="DD-MM-YYYY"
                value={
                  Array.isArray(filters.entry_date_range) && filters.entry_date_range.length === 2
                    ? [moment(filters.entry_date_range[0], 'DD-MM-YYYY'), moment(filters.entry_date_range[1], 'DD-MM-YYYY')]
                    : []
                }
                onChange={(dates, dateStrings) => {
                  const formattedRange = dates ? dates.map(date => date.format('DD-MM-YYYY')) : [];
                  handleFilterChange('entry_date_range', formattedRange);
                }}
                placeholder={['Start Entry Date', 'End Entry Date']}
                style={{ width: '100%' }}
              />
            </div>
          </Col>


          <Col span={6}>
            <div className="amount-range-input">
              <RangePicker
                className="filter_dob"

                format="DD"
                value={
                  Array.isArray(filters.joining_date_range) && filters.joining_date_range.length === 2
                    ? [moment(filters.joining_date_range[0], 'DD'), moment(filters.joining_date_range[1], 'DD')]
                    : []
                }
                onChange={(dates, dateStrings) => {
                  const formattedRange = dates ? dates.map(date => date.format('DD')) : [];
                  handleFilterChange('joining_date_range', formattedRange);
                }}
                placeholder={['Start Join Date', 'End Join Date']}
                style={{ width: '100%' }}
              />
            </div>
          </Col>





          <Col xs={24}> <Title style={{ fontSize: 13 }} level={5}>Generate Report with columns</Title>  </Col>
          <Col span={24}>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {PaymentReportOptions.map((option) => (
                <span key={option.value} style={{ marginRight: '16px', marginBottom: '10px' }}>
                  <Checkbox
                    key={option.value}
                    checked={filtersColumn[option.value]}
                    onChange={(e) => handleFilterChangeColumns(option.label, option.value, e.target.checked)}
                  >
                    {option.label}
                  </Checkbox>
                </span>
              ))}
            </div>
          </Col>
        </>

      )}

      {/* Payment Filter Start here */}
      {selectedFilterSection === 'addressFilter' && (
        <>
          <Col xs={24}> <Title style={{ fontSize: 13 }} level={5}>Permanent Address</Title>  </Col>

          <Col span={4}> <Input placeholder="Street/Building/House No" value={filters.per_address_en} onChange={e => handleFilterChange('per_address_en', e.target.value)} /></Col>
          <Col span={6}>
            <Select
              mode="multiple"
              placeholder="Village/Town/Ward (type or select)"
              style={{ width: '100%' }}
              options={villageOptions}
              value={filters.per_village_en || []}
              onChange={(values) => handleFilterChange('per_village_en', values)}
              onSearch={getVillageSuggestions}
              filterOption={false}
              showSearch
              allowClear
              optionLabelProp="value"
              maxTagCount={2}
              maxTagTextLength={12}
              loading={villageSearching}
              notFoundContent={villageSearching ? <Spin size="small" /> : <span style={{fontSize:12,color:'#999'}}>Type to search master or press Enter to add</span>}
            />
          </Col>

          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete
                placeholder="Post"
                options={optionSuggestion}
                value={filters.per_post_en}
                onChange={(value) => handleFilterChange('per_post_en', value)}
                onSearch={(text) => getPanelValue(text, 'per_post_en', 'sn_user_address')}
              />
            </div>
          </Col>

          <Col span={4}>
            <Select
              mode="multiple" showSearch filterOption={false}
              placeholder="Tehsil (type or select)"
              style={{ width: '100%' }}
              options={tehsilOptions}
              value={filters.per_tahsil_en || []}
              onSearch={getTehsilSuggestions}
              onChange={(values) => handleFilterChange('per_tahsil_en', values)}
              loading={tehsilSearching}
              notFoundContent={tehsilSearching ? <Spin size="small" /> : <span style={{fontSize:12,color:'#999'}}>Type or press Enter to add</span>}
              optionLabelProp="value"
              allowClear maxTagCount={2} maxTagTextLength={10}
            />
          </Col>

          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete
                placeholder="Pin Code"
                options={optionSuggestion}
                value={filters.per_pin_code_en}
                onChange={(value) => handleFilterChange('per_pin_code_en', value)}
                onSearch={(text) => getPanelValue(text, 'per_pin_code_en', 'sn_user_address')}
              />
            </div>
          </Col>

          <Col span={4}>
            <Select
              mode="multiple" showSearch filterOption={false}
              placeholder="District (type or select)"
              style={{ width: '100%' }}
              options={districtOptions}
              value={filters.per_district_en || []}
              onSearch={getDistrictSuggestions}
              onChange={(values) => handleFilterChange('per_district_en', values)}
              loading={districtSearching}
              notFoundContent={districtSearching ? <Spin size="small" /> : <span style={{fontSize:12,color:'#999'}}>Type or press Enter to add</span>}
              optionLabelProp="value"
              allowClear maxTagCount={2} maxTagTextLength={10}
            />
          </Col>

          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete
                placeholder="State"
                options={optionSuggestion}
                value={filters.per_state_en}
                onChange={(value) => handleFilterChange('per_state_en', value)}
                onSearch={(text) => getPanelValue(text, 'per_state_en', 'sn_user_address')}
              />
            </div>
          </Col>

          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete
                placeholder="Country"
                options={optionSuggestion}
                value={filters.per_country_en}
                onChange={(value) => handleFilterChange('per_country_en', value)}
                onSearch={(text) => getPanelValue(text, 'per_country_en', 'sn_user_address')}
              />
            </div>
          </Col>

          <Col xs={24}> <Title style={{ fontSize: 13 }} level={5}>Generate Report with columns</Title>  </Col>
          <Col span={24}>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {PerAddressReportOptions.map((option) => (
                <span key={option.value} style={{ marginRight: '16px', marginBottom: '10px' }}>
                  <Checkbox
                    key={option.value}
                    checked={filtersColumn[option.value]}
                    onChange={(e) => handleFilterChangeColumns(option.label, option.value, e.target.checked)}
                  >
                    {option.label}
                  </Checkbox>
                </span>
              ))}
            </div>
          </Col>


          <Col xs={24}> <Title style={{ fontSize: 13 }} level={5}>Temporary Address</Title>  </Col>


          <Col span={4}> <Input placeholder="House/Flat/Building" value={filters.tem_address_en} onChange={e => handleFilterChange('tem_address_en', e.target.value)} /></Col>
          <Col span={4}> <Input placeholder="Village/Town/Ward" value={filters.tem_street_en} onChange={e => handleFilterChange('tem_street_en', e.target.value)} /></Col>

          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete
                placeholder="City"
                options={optionSuggestion}
                value={filters.tem_city_en}
                onChange={(value) => handleFilterChange('tem_city_en', value)}
                onSearch={(text) => getPanelValue(text, 'tem_city_en', 'sn_user_address')}
              />
            </div>
          </Col>


          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete
                placeholder="Pin Code"
                options={optionSuggestion}
                value={filters.tem_pin_code_en}
                onChange={(value) => handleFilterChange('tem_pin_code_en', value)}
                onSearch={(text) => getPanelValue(text, 'tem_pin_code_en', 'sn_user_address')}
              />
            </div>
          </Col>

          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete
                placeholder="District"
                options={optionSuggestion}
                value={filters.tem_district_en}
                onChange={(value) => handleFilterChange('tem_district_en', value)}
                onSearch={(text) => getPanelValue(text, 'tem_district_en', 'sn_user_address')}
              />
            </div>
          </Col>

          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete
                placeholder="State"
                options={optionSuggestion}
                value={filters.tem_state_en}
                onChange={(value) => handleFilterChange('tem_state_en', value)}
                onSearch={(text) => getPanelValue(text, 'tem_state_en', 'sn_user_address')}
              />
            </div>
          </Col>

          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete
                placeholder="Country"
                options={optionSuggestion}
                value={filters.tem_country_en}
                onChange={(value) => handleFilterChange('tem_country_en', value)}
                onSearch={(text) => getPanelValue(text, 'tem_country_en', 'sn_user_address')}
              />
            </div>
          </Col>

          <Col xs={24}> <Title style={{ fontSize: 13 }} level={5}>Generate Report with columns</Title>  </Col>
          <Col span={24}>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {TemAddressReportOptions.map((option) => (
                <span key={option.value} style={{ marginRight: '16px', marginBottom: '10px' }}>
                  <Checkbox
                    key={option.value}
                    checked={filtersColumn[option.value]}
                    onChange={(e) => handleFilterChangeColumns(option.label, option.value, e.target.checked)}
                  >
                    {option.label}
                  </Checkbox>
                </span>
              ))}
            </div>
          </Col>

        </>

      )}

      {/* Occ Filter Start here */}
      {selectedFilterSection === 'occFilter' && (
        <>

          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete placeholder="Occupation"
                options={optionSuggestion}
                value={filters.occ_name}
                onChange={(value) => handleFilterChange("occ_name", value)}
                onSearch={(text) => getPanelValue(text, "occ_name", "sn_occupation")}
              />


            </div>
          </Col>

          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete placeholder="Occupation Field"
                options={optionSuggestion}
                value={filters.occ_field}
                onChange={(value) => handleFilterChange("occ_field", value)}
                onSearch={(text) => getPanelValue(text, "occ_field", "sn_occupation")}
              />
            </div>
          </Col>

          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete placeholder="Occ Category"
                options={optionSuggestion}
                value={filters.occ_category}
                onChange={(value) => handleFilterChange("occ_category", value)}
                onSearch={(text) => getPanelValue(text, "occ_category", "sn_occupation")}
              />
            </div>
          </Col>

          <Col span={4}>
            <Input placeholder="Other Specification" value={filters.other_spec} onChange={e => handleFilterChange('other_spec', e.target.value)} />
          </Col>

          <Col span={4}>
            <Input placeholder="Shop No./Plot" value={filters.shop_no} onChange={e => handleFilterChange('shop_no', e.target.value)} />
          </Col>

          <Col span={4}>
            <Input placeholder="Building Name" value={filters.building_name} onChange={e => handleFilterChange('building_name', e.target.value)} />
          </Col>

          <Col span={4}>
            <Input placeholder="Street" value={filters.occ_street} onChange={e => handleFilterChange('occ_street', e.target.value)} />
          </Col>

          <Col span={4}>
            <Input placeholder="Locality/Area" value={filters.occ_locality} onChange={e => handleFilterChange('occ_locality', e.target.value)} />
          </Col>


          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete placeholder="District"
                options={optionSuggestion}
                value={filters.occ_district}
                onChange={(value) => handleFilterChange("occ_district", value)}
                onSearch={(text) => getPanelValue(text, "occ_district", "sn_occupation")}
              />
            </div>
          </Col>

          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete placeholder="State"
                options={optionSuggestion}
                value={filters.state}
                onChange={(value) => handleFilterChange("occ_state", value)}
                onSearch={(text) => getPanelValue(text, "occ_state", "sn_occupation")}
              />
            </div>
          </Col>

          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete placeholder="Country"
                options={optionSuggestion}
                value={filters.occ_country}
                onChange={(value) => handleFilterChange("occ_country", value)}
                onSearch={(text) => getPanelValue(text, "occ_country", "sn_occupation")}
              />
            </div>
          </Col>

          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete placeholder="Pincode"
                options={optionSuggestion}
                value={filters.occ_zip_code}
                onChange={(value) => handleFilterChange("occ_zip_code", value)}
                onSearch={(text) => getPanelValue(text, "occ_zip_code", "sn_occupation")}
              />
            </div>
          </Col>

          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete placeholder="Office Phone no."
                options={optionSuggestion}
                value={filters.occ_office_phone_no}
                onChange={(value) => handleFilterChange("occ_office_phone_no", value)}
                onSearch={(text) => getPanelValue(text, "occ_office_phone_no", "sn_occupation")}
              />
            </div>
          </Col>

          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete placeholder="Mobile no."
                options={optionSuggestion}
                value={filters.occ_mobile_no}
                onChange={(value) => handleFilterChange("occ_mobile_no", value)}
                onSearch={(text) => getPanelValue(text, "occ_mobile_no", "sn_occupation")}
              />
            </div>
          </Col>

          <Col xs={24}> <Title style={{ fontSize: 13 }} level={5}>Generate Report with columns</Title>  </Col>
          <Col span={24}>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {OccReportOptions.map((option) => (
                <span key={option.value} style={{ marginRight: '16px', marginBottom: '10px' }}>
                  <Checkbox
                    key={option.value}
                    checked={filtersColumn[option.value]}
                    onChange={(e) => handleFilterChangeColumns(option.label, option.value, e.target.checked)}
                  >
                    {option.label}
                  </Checkbox>
                </span>
              ))}
            </div>
          </Col>

        </>

      )}
      {/* Family Filter Start here */}
      {selectedFilterSection === 'familyFilter' && (
        <>

          <Col span={4}>
            <Input placeholder="Name" value={filters.m_name} onChange={e => handleFilterChange('m_name', e.target.value)} />
          </Col>
          <Col span={4}>
            <Input placeholder="Relation with" value={filters.m_relation_name} onChange={e => handleFilterChange('m_relation_name', e.target.value)} />
          </Col>

          <Col span={4} >
            <Select style={{ width: '100%' }} placeholder="Gender" value={filters.m_gender} onChange={value => handleFilterChange('m_gender', value)}>
              <Option value="">Select</Option>
              <Option value="Male">Male</Option>
              <Option value="Female">Female</Option>
              <Option value="Other">Other</Option>
            </Select>
          </Col>


          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete placeholder="Education"
                options={optionSuggestion}
                value={filters.m_education}
                onChange={(value) => handleFilterChange("m_education", value)}
                onSearch={(text) => getPanelValue(text, "m_education", "sn_family_members")}
              />
            </div>
          </Col>

          <Col span={4}>
            <div className="auto-complete-container">
              <AutoComplete placeholder="Occupation"
                options={optionSuggestion}
                value={filters.m_occupation}
                onChange={(value) => handleFilterChange("m_occupation", value)}
                onSearch={(text) => getPanelValue(text, "m_occupation", "sn_family_members")}
              />
            </div>
          </Col>

          <Col span={4}>
            <Input placeholder="Current Address" value={filters.m_current_address} onChange={e => handleFilterChange('m_current_address', e.target.value)} />
          </Col>

          <Col span={4}>
            <Input placeholder="Phone Number" value={filters.m_phone_no} onChange={e => handleFilterChange('m_phone_no', e.target.value)} />
          </Col>

          <Col span={4}>
            <Input placeholder="Email" value={filters.m_email} onChange={e => handleFilterChange('m_email', e.target.value)} />
          </Col>

          <Col xs={24}> <Title style={{ fontSize: 13 }} level={5}>Generate Report with columns</Title>  </Col>
          <Col span={24}>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {FamilyReportOptions.map((option) => (
                <span key={option.value} style={{ marginRight: '16px', marginBottom: '10px' }}>
                  <Checkbox
                    key={option.value}
                    checked={filtersColumn[option.value]}
                    onChange={(e) => handleFilterChangeColumns(option.label, option.value, e.target.checked)}
                  >
                    {option.label}
                  </Checkbox>
                </span>
              ))}
            </div>
          </Col>

        </>

      )}

      {/* Social Filter Start here */}
      {selectedFilterSection === 'socialFilter' && (
        <>

          <Col span={4}>
            <Input placeholder="Org. Name" value={filters.sn_organisation_name} onChange={e => handleFilterChange('sn_organisation_name', e.target.value)} />
          </Col>
          <Col span={4}>
            <Input placeholder="Post" value={filters.sn_post} onChange={e => handleFilterChange('sn_post', e.target.value)} />
          </Col>
          <Col span={4}>
            <DatePicker className="filter_dob CustomInputSet"
              format="DD-MM-YYYY" value={filters.sn_duration_start ? moment(filters.sn_duration_start, 'DD-MM-YYYY') : null}
              onChange={(date, dateString) => handleFilterChange('sn_duration_start', dateString)} placeholder="Start date"
            />


          </Col>
          <Col span={4}>
            <DatePicker className="filter_dob CustomInputSet"
              format="DD-MM-YYYY" value={filters.sn_duration_end ? moment(filters.sn_duration_end, 'DD-MM-YYYY') : null}
              onChange={(date, dateString) => handleFilterChange('sn_duration_end', dateString)} placeholder="End date"
            />

          </Col>
          <Col span={4}>
            <Input placeholder="Org. Address" value={filters.sn_organisation_address} onChange={e => handleFilterChange('sn_organisation_address', e.target.value)} />
          </Col>
          <Col span={4}>
            <Input placeholder="Org.Mobile No" value={filters.org_phone_no} onChange={e => handleFilterChange('org_phone_no', e.target.value)} />
          </Col>

          <Col xs={24}> <Title style={{ fontSize: 13 }} level={5}>Generate Report with columns</Title>  </Col>
          <Col span={24}>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {SocialReportOptions.map((option) => (
                <span key={option.value} style={{ marginRight: '16px', marginBottom: '10px' }}>
                  <Checkbox
                    key={option.value}
                    checked={filtersColumn[option.value]}
                    onChange={(e) => handleFilterChangeColumns(option.label, option.value, e.target.checked)}
                  >
                    {option.label}
                  </Checkbox>
                </span>
              ))}
            </div>
          </Col>


        </>

      )}

      <Row gutter={16} style={{ marginBottom: '16px', textAlign: 'right' }}>
        <Col span={24} style={{ display: 'flex', justifyContent: 'flex-start', gap: '10px' }}>
          <Button icon={<SearchOutlined />} onClick={handleSearchReport} style={{ background: '#7a0000', color: '#fff', borderColor: '#7a0000' }}>
            Search Report
          </Button>
          <Button type="default" onClick={handleResetFilters}>
            Reset Filters
          </Button>
          {hasPermission('/reports/manual-report', 'downloadPermission') && (
          <Button type="default" icon={<FileExcelOutlined />} onClick={handleExcelDownload}>
            Excel Download
          </Button>
          )}
          {/* <Button type="default" icon={<FilePdfOutlined />} onClick={handlePdfDownload}>
            PDF Download
          </Button> */}
        </Col>
      </Row>

    </>

  );
}


export default FilterReport;
